var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 42H18M30 42V25.2C30 24.8818 29.8736 24.5765 29.6485 24.3515C29.4235 24.1265 29.1183 24 28.8 24H19.2C18.8817 24 18.5765 24.1265 18.3515 24.3515C18.1264 24.5765 18 24.8818 18 25.2V42M30 42H40.8C41.1183 42 41.4235 41.8736 41.6485 41.6486C41.8736 41.4235 42 41.1183 42 40.8V36.2C42 35.8818 41.8736 35.5765 41.6485 35.3515C41.4235 35.1265 41.1183 35 40.8 35H31.2C30.8817 35 30.5765 35.1265 30.3515 35.3515C30.1264 35.5765 30 35.8818 30 36.2V42ZM18 42V32.2C18 31.8818 17.8736 31.5765 17.6485 31.3515C17.4235 31.1265 17.1183 31 16.8 31H7.2C6.88174 31 6.57652 31.1265 6.35147 31.3515C6.12643 31.5765 6 31.8818 6 32.2V40.8C6 41.1183 6.12643 41.4235 6.35147 41.6486C6.57652 41.8736 6.88174 42 7.2 42H18ZM21.612 10.226L23.43 6.37203C23.4791 6.26186 23.559 6.16827 23.6602 6.10259C23.7614 6.03691 23.8794 6.00195 24 6.00195C24.1206 6.00195 24.2386 6.03691 24.3398 6.10259C24.441 6.16827 24.5209 6.26186 24.57 6.37203L26.39 10.226L30.454 10.848C30.976 10.928 31.184 11.6 30.806 11.984L27.866 14.984L28.56 19.22C28.648 19.764 28.104 20.18 27.636 19.922L24 17.922L20.364 19.922C19.898 20.178 19.352 19.764 19.44 19.22L20.134 14.984L17.194 11.984C16.814 11.6 17.024 10.928 17.544 10.848L21.612 10.226Z",
    stroke: "#DB3353",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.54b2502e4f95dcd1fb394ddd055f9e69.svg";
export { ForwardRef as ReactComponent };